function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1"
}, /*#__PURE__*/React.createElement("g", {
  fill: "rgb(0,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m25.86 17.45h-5.02c-1.8701 0-3.39 1.52-3.39 3.39v5.02c0 1.87 1.52 3.39 3.39 3.39h5.02c1.87 0 3.39-1.52 3.39-3.39v-5.02c0-1.87-1.52-3.39-3.39-3.39zm1.39 8.41c0 .76-.63 1.39-1.39 1.39h-5.02c-.76 0-1.39-.63-1.39-1.39v-5.02c0-.77.63-1.39 1.39-1.39h5.02c.76 0 1.39.62 1.39 1.39z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m25.86 2.75h-5.02c-1.8701 0-3.39 1.52-3.39 3.39v5.02c0 1.8701 1.52 3.39 3.39 3.39h5.02c1.87 0 3.39-1.52 3.39-3.39v-5.02c0-1.87-1.52-3.39-3.39-3.39zm1.39 8.41c0 .77-.63 1.39-1.39 1.39h-5.02c-.76 0-1.39-.62-1.39-1.39v-5.02c0-.76.63-1.39 1.39-1.39h5.02c.76 0 1.39.63 1.39 1.39z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m11.16 17.45h-5.02c-1.87 0-3.39 1.52-3.39 3.39v5.02c0 1.87 1.52 3.39 3.39 3.39h5.02c1.8701 0 3.39-1.52 3.39-3.39v-5.02c0-1.87-1.52-3.39-3.39-3.39zm1.39 8.41c0 .76-.62 1.39-1.39 1.39h-5.02c-.76 0-1.39-.63-1.39-1.39v-5.02c0-.77.63-1.39 1.39-1.39h5.02c.77 0 1.39.62 1.39 1.39z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m11.16 2.75h-5.02c-1.87 0-3.39 1.52-3.39 3.39v5.02c0 1.8701 1.52 3.39 3.39 3.39h5.02c1.8701 0 3.39-1.52 3.39-3.39v-5.02c0-1.87-1.52-3.39-3.39-3.39zm1.39 8.41c0 .77-.62 1.39-1.39 1.39h-5.02c-.76 0-1.39-.62-1.39-1.39v-5.02c0-.76.63-1.39 1.39-1.39h5.02c.77 0 1.39.63 1.39 1.39z"
})));

var SvgApps = function SvgApps(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgApps, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/apps.598fe592.svg";
export { ForwardRef as ReactComponent };